import './plot.css'
import React, { Component } from "react";


function modulus(x1, x2, x3) {
    return Math.sqrt(x1 * x1 + x2 * x2 + x3 * x3);
}

function GetModDeslocamentos(deslocArr) {
    if (deslocArr.length == 0)
        return 0;
    let arr = [];

    for (let i = 0; i < deslocArr.length; i += 3) {
        arr.push(modulus(deslocArr[i], deslocArr[i + 1], deslocArr[i + 2]));
    }
    return arr;
}

function GetDeslocamentosHor(deslocArr) {
    if (deslocArr.length == 0)
        return 0;
    let arr = [];
    for (let i = 0; i < deslocArr.length; i += 3) {
        arr.push(modulus(deslocArr[i], deslocArr[i + 1], 0));
    }
    return arr;
}

function GetDeslocamentosVer(deslocArr) {
    if (deslocArr.length == 0)
        return 0;
    let arr = [];
    for (let i = 0; i < deslocArr.length; i += 3) {
        arr.push(deslocArr[i + 2]);
    }
    return arr;
}

function RenderLegend(displacementArray, displacementAxis, displacementUnits) {
    let min = Math.min.apply(Math, displacementArray)
    let max = Math.max.apply(Math, displacementArray)

    if (min < 0 && max < 0) {
        if (Math.abs(min) > Math.abs(max)) {
            let temp = min
            min = max
            max = temp
        }
        return <div className='color-bar'>
            <div className='bar-title'>{displacementAxis}&nbsp;{displacementUnits}</div>
            <div className='max-value'>{max.toFixed(1)}</div>
            <div className='mid-value'>{((max + min) / 2).toFixed(1)}</div>
            <div className='min-value'>{min.toFixed(1)}</div>
        </div>

    }
    return <div className='legend'>
        <div className='bar-title'>{displacementAxis}&nbsp;{displacementUnits}</div>
        <div className='color-bar'>
            <p className='max-value'>{Math.max.apply(Math, displacementArray).toFixed(1)}</p>
            <p className='mid-value'>{((Math.max.apply(Math, displacementArray) + (Math.min.apply(Math, displacementArray))) / 2).toFixed(1)}</p>
            <p className='min-value'>{Math.min.apply(Math, displacementArray).toFixed(1)}</p>
        </div>
    </div>
}


export { GetModDeslocamentos, GetDeslocamentosHor, GetDeslocamentosVer, RenderLegend };